exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".viewstrap.feature-branch-warning{width:100%;text-align:center;background-color:#faeec4;padding:4px;font-weight:700}.viewstrap.feature-branch-warning .reset-button{position:absolute;right:4px}", ""]);

// exports
